import { Button, Col, Form, Input, Row, Select } from "antd";
import "./styles.scss";
import { ReactSVG } from "react-svg";
import { CHAT_ICON } from "assets";

const JoinSection = () => {
  return (
    <section className="join-section">
      <div className="container">
        <Row align={"middle"} gutter={[20, 40]}>
          <Col xs={24} lg={12} className="join-section-left">
            <div className="join-section-left-inner">
              <ReactSVG src={CHAT_ICON} />
              <div className="join-section-left-top">
                <h2 className="color-white">Join Our Journey</h2>
                <p className="jakarta-sans-font font-18 m-0">
                  Welcome to Agape IT—where technology meets heart
                </p>
              </div>
              <p className="jakarta-sans-font font-18 line-height-medium join-section-left-bottom">
                As you explore our website, remember that Agape IT isn’t just
                about lines of code; it’s about the people behind them. Let’s
                create a tech-infused future where compassion and innovation go
                hand in hand
              </p>
            </div>
          </Col>
          <Col xs={24} lg={12} className="join-section-right">
            <JoinForm />
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default JoinSection;

const JoinForm = () => (
  <Form layout="vertical" className="join-form">
    <Form.Item label="Name">
      <Input placeholder="i.e. John Doe" />
    </Form.Item>
    <Form.Item label="Email">
      <Input placeholder="i.e. john@gmail.com" />
    </Form.Item>
    <Form.Item label="Phone">
      <Input placeholder="i.e. 123-456-7890" />
    </Form.Item>
    <Form.Item label="Which service do you need">
      <Select placeholder="Select a Service" />
    </Form.Item>
    <div className="join-form-submit-button">
    <Button type="primary" size="large" block>
      Join Now
    </Button>
    </div>
  </Form>
);
